import { render } from "./TagTemplates.vue?vue&type=template&id=41faaaf7&scoped=true"
import script from "./TagTemplates.vue?vue&type=script&lang=js"
export * from "./TagTemplates.vue?vue&type=script&lang=js"

import "./TagTemplates.vue?vue&type=style&index=0&id=41faaaf7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41faaaf7"]])

export default __exports__